import { Input as InputShadcn } from '@bpinternal/ui-kit-next'
import { ComponentProps } from 'react'
import { cn } from '../utils'

export const Input = ({ ref, className, ...props }: ComponentProps<typeof InputShadcn>) => {
  return <InputShadcn type="text" ref={ref} {...props} className={cn('w-full', className)} />
}
Input.displayName = 'Input'
